import { callService } from "../tools";

export const obtenerListaFacturas = (sParam) => {
	return dispatch => {
		let request = {
			"poliza": sParam.poliza,
			"rfcReceptor": sParam.rfcReceptor,
			"version": sParam.version,
			"fechaInicio": sParam.fechaInicio,
			"fechaFin": sParam.fechaFin,
			"ramo": sParam.ramo
		};
		new callService({
			service: "facturas.listadoFacturas",
			"secure": true,
			data: request,
			json: true
		}).execute().then(body => {
			if (body.hasOwnProperty("error")) { }
			else {
				console.log(body);

				body.cfds.cfd.sort(function (a, b) {
					return new Date(b.fechaEmision) - new Date(a.fechaEmision);
				});

				console.log(body.cfds.cfd);

				dispatch({
					"type": "SET_LISTA_FACTURAS",
					"listaFacturas": body.cfds.cfd
				});
			}
		}).catch(() => {
			dispatch({
				"type": "SET_LISTA_FACTURAS",
				"titulo": "Error",
				"mensaje": "Hubo un error al obtener las facturas del la póliza"
			});
		});
	};
};



// WEBPACK FOOTER //
// ./src/home/facturas.act.js